import {
  ActivityStreamActorType,
  FetchGuestNotificationsQuery,
} from '@website/types/graphqlOperations';

export default function composeNotificationActorsPictureObject(
  activities: Pick<
    FetchGuestNotificationsQuery['user']['notifications']['items'][0],
    'actor'
  >[],
) {
  const uniqueActorsIDs = new Set<string>();
  activities.forEach((activity) => {
    const { id, type } = activity.actor;
    if (id && type !== ActivityStreamActorType.SYSTEM) {
      uniqueActorsIDs.add(id);
    }
  });
  const filterDuplicateActors = Array.from(uniqueActorsIDs).map((id) =>
    activities.find((activity) => activity.actor.id === id),
  );
  return filterDuplicateActors.slice(0, 2).map((activity) => ({
    defaultText:
      activity.actor?.user?.givenName ??
      activity.actor?.host?.name ??
      activity.actor?.name,
    picture: activity.actor?.user?.picture ?? activity.actor?.host?.logo,
  }));
}
